import { Pipe, PipeTransform } from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({
    name: 'searchFilter',
})
export class SearchFilterPipe implements PipeTransform {
    datePipe = new DatePipe('en-US');

    transform(items: any[], searchParam: string, searchValue: string ): any {
        return !items ? [] : !searchParam ? items : items.filter((item) => {
            if (!(isNaN(item[searchParam]) && !isNaN(Date.parse(item[searchParam])))) {
                return String(item[searchParam]).toLowerCase().includes(searchValue.toLowerCase());
            } else {
                return this.datePipe.transform(item[searchParam], 'shortDate').includes(searchValue);
            }
        });
    }
}
